/**
 * Created by Yangxunwu on 2018/6/21.
 */

import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import salary from './modules/salary'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		user,
		salary,
	},
	getters 
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js